import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useHistory } from "react-router";
import CookbookMobile from "./images/cookbook_mobile.jpg";
import CookbookDesktop from "./images/cookbook_mobile.jpg";
import MacroMobile from "./images/macro_mobile.jpg";
import MacroDesktop from "./images/macro_desktop.jpg";
import ArticleMobile from "./images/articles_mobile.jpg";
import ArticleDesktop from "./images/articles_desktop.jpg";
import styles from "./styles.module.scss";
import Eyebrow from "Root/profile/components/common/Eyebrow";
import { useScreenWidth } from "Root/profile/components/SubscriptionPageV2/hooks";
import LargeFont from "Root/profile/components/common/LargeFont";
import H2Font from "Root/profile/components/common/H2Font";
const resources = [
    {
        title: "Gainful’s Cookbook",
        mobile_image: CookbookMobile,
        link: "https://dlye1hka1kz5z.cloudfront.net/uploads/GainfulCookbook.pdf",
        desktop_image: CookbookDesktop,
        target: "_blank",
    },
    {
        title: "Macronutrient Calculator",
        mobile_image: MacroMobile,
        link: "/macro-tool?from=target-results-page",
        desktop_image: MacroDesktop,
    },
    {
        title: "Articles Picked for You",
        mobile_image: ArticleMobile,
        link: "https://www.gainful.com/blog/",
        desktop_image: ArticleDesktop,
        target: "_blank",
    },
];
const TargetResultsResources = () => {
    const history = useHistory();
    const isMobile = useScreenWidth() < 968;
    return (_jsxs("div", { className: styles.resource, children: [_jsxs("div", { className: styles.title, children: [_jsx(Eyebrow, { children: "enhance your knowledge" }), _jsx(H2Font, { children: "Resources Just for You" })] }), _jsx("div", { className: styles.items, children: resources.map((item) => (_jsxs("a", { className: styles.resource_item, href: item.link, target: item.target, children: [_jsx("img", { src: isMobile ? item.mobile_image : item.desktop_image, alt: "" }), _jsx("span", { className: styles.text, children: _jsx(LargeFont, { children: item.title }) }), _jsx("div", { className: styles.button, children: _jsx("svg", { width: "15", height: "10", viewBox: "0 0 15 10", xmlns: "http://www.w3.org/2000/svg", children: _jsx("path", { stroke: "#fff", d: "M0.519531 4.99993H13.4795M13.4795 4.99993L9.02782 0.679932M13.4795 4.99993L9.02782 9.31993", strokeWidth: "1.5" }) }) })] }, item.title))) })] }));
};
export default TargetResultsResources;
